import { NextRequest, NextResponse } from 'next/server'
import { and, eq } from 'drizzle-orm'
import { requireExpertApiUser } from '@/lib/role-guard'
import { db } from '@/db'
import { projects } from '@/db/schema'

export async function PATCH(
  request: NextRequest,
  { params }: { params: Promise<{ id: string }> },
) {
  const auth = await requireExpertApiUser()
  if (!auth.ok) return auth.response

  const { id } = await params
  const body = await request.json().catch(() => ({}))

  if (!('isActive' in body) || typeof body.isActive !== 'boolean') {
    return NextResponse.json({ error: 'isActive (boolean) is required' }, { status: 400 })
  }

  const [updated] = await db
    .update(projects)
    .set({ isActive: body.isActive, updatedAt: new Date() })
    .where(and(eq(projects.id, id), eq(projects.tenantId, auth.user.tenantId)))
    .returning()

  if (!updated) {
    return NextResponse.json({ error: 'Project not found' }, { status: 404 })
  }

  return NextResponse.json(updated)
}
